export const VOTING_DETAILS_VALUE = '1';
export const VOTING_RESULT_VALUE = '2';
export const RATIONALE_VALUE = '3';
export const INVESTOR_VOTING_VALUE = '3';
export const INTERNAL_VALUE = '4';
export const COMPANY_RESULTS_VALUE = '5';

export const SAY_ON_PAY_FREQUENCY_PROPOSAL_TYPE = 'Say on Pay Frequency';

export const SAY_ON_PAY_FREQUENCY_RESULT_FIELDS = [
  { field: 'one_year_pcent', frequency: '1 Year' },
  { field: 'two_year_pcent', frequency: '2 Years' },
  { field: 'three_year_pcent', frequency: '3 Years' },
];

export const ADV_VOTING_SEARCH_FAILURE_MSG = (
  <>
    <div>Unable to load search results. Please try again.</div>
    <div>
      If the problem persists, email the team at{' '}
      <a className="text-secondary" href="mailto:dmi.support@diligent.com">
        dmi.support@diligent.com
      </a>
      .
    </div>
  </>
);

export default {
  VOTING_DETAILS_VALUE,
  VOTING_RESULT_VALUE,
  RATIONALE_VALUE,
  INTERNAL_VALUE,
  INVESTOR_VOTING_VALUE,
  COMPANY_RESULTS_VALUE,
  SAY_ON_PAY_FREQUENCY_PROPOSAL_TYPE,
  SAY_ON_PAY_FREQUENCY_RESULT_FIELDS,
  ADV_VOTING_SEARCH_FAILURE_MSG,
};
